<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.app-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
